import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';

interface PrismTabsContainerTabContentSignature {
  Args: {
    activeTabId: string;
    id: string;
  };
  Blocks: {
    default: [];
  };
}

const PrismTabsContainerTabContent = <template>
  {{#if (eq @id @activeTabId)}}
    <section>
      {{yield}}
    </section>
  {{/if}}
</template> satisfies TOC<PrismTabsContainerTabContentSignature>;

export default PrismTabsContainerTabContent;
